import React, { useEffect, useState } from "react";
import { ArrowLeftRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { SLOT_DEFINITIONS } from "../../lib/showcaseSlots";

export const ProductSwapDialog = ({ source, products, slots, onClose, onSwap, onReturnFocus }) => {
  const [target, setTarget] = useState(null);
  useEffect(() => { setTarget(null); }, [source]);
  const product = products.find((p) => p.slug === source);
  return (
    <Dialog open={Boolean(source)} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-h-[90dvh] overflow-y-auto product-identity-surface" style={{ "--product-swatch": product?.swatch }} data-testid="showcase-reorder-dialog" onCloseAutoFocus={(event) => { event.preventDefault(); onReturnFocus(); }}>
        <DialogHeader className="text-left">
          <DialogTitle className="font-heading text-2xl" data-testid="showcase-reorder-title">Swap {product?.display_name}</DialogTitle>
          <DialogDescription data-testid="showcase-reorder-description">Choose another card to exchange positions. Product details and notes stay with their product.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 gap-2" role="group" aria-label="Swap with">
          {SLOT_DEFINITIONS.map((slot) => {
            const option = products.find((p) => p.slug === slots[slot.id]);
            if (!option || option.slug === source) return null;
            return (
              <Button key={slot.id} variant="outline" className="h-auto min-h-11 justify-start whitespace-normal py-2 text-left" aria-pressed={target === option.slug} onClick={() => setTarget(option.slug)} data-testid={`showcase-reorder-swap-option-${option.slug}`}>
                <span className="product-identity-dot" style={{ "--product-swatch": option.swatch }} aria-hidden="true" />
                <ArrowLeftRight aria-hidden="true" />
                <span className="min-w-0"><span className="block">{option.display_name}</span><span className="block text-xs text-muted-foreground">{slot.label}</span></span>
              </Button>
            );
          })}
        </div>
        <DialogFooter className="gap-2">
          <Button variant="ghost" className="min-h-11" onClick={onClose} data-testid="showcase-reorder-cancel">Cancel</Button>
          <Button className="min-h-11" disabled={!target} onClick={() => { onSwap(source, target); onClose(); }} data-testid="showcase-reorder-confirm-button">Swap positions</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
